import React from 'react';
import { Button } from '@mui/material';

interface DialogActionButtonsProps {
  onCancel: () => void;
  onSubmit: () => void;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
  onCancel,
  onSubmit,
}) => (
  <>
    <Button
      onClick={onCancel}
      sx={{
        color: '#64748b',
        '&:hover': {
          backgroundColor: '#f1f5f9',
          color: '#475569'
        }
      }}
    >
      Cancel
    </Button>
    <Button
      onClick={onSubmit}
      variant="contained"
      sx={{
        backgroundColor: '#162346',
        '&:hover': {
          backgroundColor: '#1a2a52',
        },
        fontWeight: 600,
        ml: 1
      }}
    >
      Add Scheduled Procedure Code
    </Button>
  </>
);
